import { useBackgroundAudioPlayerStore } from '@/shared/components/players/BackgroundAudioPlayer/store.ts';
import { MaybeNull } from '@/shared/types';
import { storeToRefs } from 'pinia';
import {
  onMounted,
  Ref,
  watch,
} from 'vue';

interface YoutubePlayerLike {
  mute: () => void;
  unMute: () => void;
}

export interface UseYouTubePlayerControlProps {
  player: Ref<MaybeNull<YoutubePlayerLike>>,
  manualMute?: boolean,
}

export const useYouTubePlayerControl = (props: UseYouTubePlayerControlProps) => {
  const { soundEnabled } = storeToRefs(useBackgroundAudioPlayerStore());

  onMounted(() => {
    if (!props.manualMute) {
      updateMuteOfPlayer();
    }
  });

  watch(() => soundEnabled.value, () => {
    if (!props.manualMute) {
      updateMuteOfPlayer();
    }
  });

  const updateMuteOfPlayer = () => {
    if (!props.player.value) {
      return;
    }

    if (soundEnabled.value) {
      props.player.value.unMute();
    } else {
      props.player.value.mute();
    }
  };

  return {
  };
};
